module.exports = __webpack_public_path__ + "img/insta.3a1b982e.svg";